import Vue from "vue";

Vue.prototype.$highlowmeasu = [
  { key: "foot_long", high: true, low: true },
  { key: "circ_meta", high: true, low: true },
  { key: "circ_retro_meta", high: true, low: true },
  { key: "circ_neck", high: true, low: true },
  { key: "circ_past", high: true, low: true },
  { key: "circ_ankle", high: true, low: true },
  { key: "high_ankle", high: true, low: true },
  { key: "circ_leg", high: true, low: false },
  { key: "high_leg", high: true, low: false },
  { key: "circ_end_tom", high: true, low: false },
  { key: "high_tom", high: true, low: false },
  { key: "high_fings", high: true, low: true },
  { key: "high_heel", high: true, low: true }
];
